import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateBank = (props) => {
    const [BankName, setBankName] = useState('');
    const [AccountNo, setAccountNo] = useState('');
    // const [NameOfBankAcccount,setNameOfBankAcccount] = useState('');
    const [Address, setAddress] = useState('');
    const [CurrencyID, setCurrencyID] = useState('');
    const [CompanyID, setCompanyID] = useState('');
    const [IntermediaryBankName, setIntermediaryBankName] = useState('');
    const [SwiftCode, setSwiftCode] = useState('');
    const [IFSCCode, setIFSCCode] = useState('');
    const [IntermediaryBankAddress, setIntermediaryBankAddress] = useState('');
    const [response, fetchData] = UseFetchData();
    const [Currencycmb, setCurrencycmb] = useState([]);
    const [Companycmb, setCompanycmb] = useState([]);
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseComboCom, fetchComboComData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        BankName: Yup.string().required('Required!'),
        AccountNo: Yup.number().required('Required!'),
        CurrencyID: Yup.string().required('Required!'),
        CompanyID: Yup.string().required('Required!'),
    });

    const onSubmit = (values) => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'BankMaster');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.BankName);
        bodyFormData.append("Value2", values.AccountNo);
        bodyFormData.append("Value3", values.Address);
        bodyFormData.append("Value4", values.CurrencyID);
        bodyFormData.append("Value5", values.IntermediaryBankName);
        bodyFormData.append("Value6", values.IFSCCode);
        bodyFormData.append("Value7", values.SwiftCode);
        bodyFormData.append("Value8", values.IntermediaryBankAddress);
        bodyFormData.append("Value9", values.CompanyID);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'BankMaster');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    const CurrencyData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Currency');
        fetchComboData("Primary/List", bodyFormData);
    }

    const CurrencydataOpt = (CurrencyOption) => {
        // debugger;
        let CurrencyCombo = CurrencyOption.map((data) =>
            <option
                key={data.Currency}
                value={data.id}
            >
                {data.Currency}
            </option>
        );
        setCurrencycmb(CurrencyCombo);
    };


    const CompanyData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Company');
        fetchComboComData("Primary/List", bodyFormData);
    }

    const CompanydataOpt = (CompanyOption) => {
        let CompanyCombo = CompanyOption.map((data) =>
            <option
                key={data.Company}
                value={data.id}
            >
                {data.Company}
            </option>
        );
        setCompanycmb(CompanyCombo);
    };

    useEffect(() => {
        // debugger;
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])

    useEffect(() => {
        // debugger;
        CurrencydataOpt(responseCombo);
    }, [responseCombo])

    useEffect(() => {
        // debugger;
        CompanydataOpt(responseComboCom);
    }, [responseComboCom])

    useEffect(() => {
        if (responseGetData.length > 0) {
            setBankName(responseGetData[0].BankName === null ? "" : responseGetData[0].BankName);
            setAccountNo(responseGetData[0].AccountNo === null ? "" : responseGetData[0].AccountNo);
            setAddress(responseGetData[0].Address === null ? "" : responseGetData[0].Address === null);
            setCurrencyID(responseGetData[0].CurrencyID === null ? "" : responseGetData[0].CurrencyID);
            setCompanyID(responseGetData[0].CompanyID === null ? "" : responseGetData[0].CompanyID);
            setIntermediaryBankName(responseGetData[0].IntermediaryBankName === null ? "" : responseGetData[0].IntermediaryBankName);
            setIFSCCode(responseGetData[0].IFSCCode === null ? "" : responseGetData[0].IFSCCode);
            setSwiftCode(responseGetData[0].SwiftCode === null ? "" : responseGetData[0].SwiftCode);
            setIntermediaryBankAddress(responseGetData[0].IntermediaryBankAddress === null ? "" : responseGetData[0].IntermediaryBankAddress);
        }
    }, [responseGetData])

    useEffect(() => {
        CurrencyData();
        CompanyData();
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{
                BankName: BankName, AccountNo: AccountNo, Address: Address, CurrencyID: CurrencyID, CompanyID: CompanyID,
                IntermediaryBankName: IntermediaryBankName, IFSCCode: IFSCCode, SwiftCode: SwiftCode, IntermediaryBankAddress: IntermediaryBankAddress
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Bank Name'
                                    name='BankName'
                                    onChange={(e) => setBankName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='BankAccount Number'
                                    name='AccountNo'
                                    onChange={(e) => setAccountNo(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Address'
                                    name='Address'
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Account currency'
                                    name='CurrencyID'
                                    options={Currencycmb}
                                    onChange={(e) => setCurrencyID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Company'
                                    name='CompanyID'
                                    options={Companycmb}
                                    onChange={(e) => setCompanyID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='IFSC Code'
                                    name='IFSCCode'
                                    onChange={(e) => setIFSCCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='INTERMEDIARY BANK NAME'
                                    name='IntermediaryBankName'
                                    onChange={(e) => setIntermediaryBankName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='SWIFT CODE'
                                    name='SwiftCode'
                                    onChange={(e) => setSwiftCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='BANK PHYSICAL ADDRESS'
                                    name='IntermediaryBankAddress'
                                    onChange={(e) => setIntermediaryBankAddress(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateBank;
